import { Button } from '@cokitchen/cokitchen-components';
import React, { useEffect, useRef, useState } from 'react';
import FundWalletModal from '../fund-wallet-modal';
import useAxios from 'hooks/useAxios';
import useDashboardContext from 'contexts/dashboard.context';
import { QueryLowBalanceResponse } from 'models/cokitchen.model';

const LowBalanceModal = () => {
  const day = new Date().getDay();
  const mounted = useRef(false);
  const { activeCompany } = useDashboardContext();
  const [showTopUpModal, setShowTopUpModal] = useState(false);

  const { response, fetchData } = useAxios<QueryLowBalanceResponse>({
    url: 'company/low-wallet-balance',
    method: 'post',
    body: { company_id: activeCompany?.id, day }
  });
  useEffect(() => {
    if (mounted.current && activeCompany?.id) fetchData();
    return () => {
      mounted.current = true;
    };
  }, [activeCompany?.id]);

  if (!response?.data?.data?.low_balance) return null;
  return (
    <div>
      <div className='w-full z-30 bg-[#FFF9F0] sm:min-h-[63px] h-fit py-2 sm:py-4 flex justify-center items-center gap-2 sm:gap-4 md:gap-16 flex-wrap'>
        <p className='text-[#FF9500] text-center'>
          <span className='font-medium'> ⚠️</span>&nbsp;Your wallet balance is low, your budget
          allocation is paused until you top up
        </p>
        <Button
          variant='outline'
          color='transparent'
          className='!bg-white w-[139px] h-[39px] border-[#FFEFD6] text-[#FF9500] font-medium'
          onClick={() => setShowTopUpModal(true)}>
          Top Up Wallet
        </Button>
      </div>
      <FundWalletModal isOpen={showTopUpModal} onClose={() => setShowTopUpModal(false)} />
    </div>
  );
};

export default LowBalanceModal;
